import script from "./AttachmentOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentOptions.vue?vue&type=script&setup=true&lang=js"

import "./AttachmentOptions.vue?vue&type=style&index=0&id=0b19da6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b19da6e"]])

export default __exports__